const { CHANNEL_INTERFACE_TYPE, CHANNEL_INTERFACE_TEXT } = require('@/enums');
const { transformEnumToOptions } = require('@/tools');

module.exports = () => {
  return {
    type: {
      label: '媒体平台',
      type: 'select',
      props: {
        disabled: true,
      },
      options: transformEnumToOptions({ labels: CHANNEL_INTERFACE_TEXT, values: CHANNEL_INTERFACE_TYPE }),
      value: '',
    },
    advertiser_id: {
      label: '广告主ID',
      type: 'input',
      props: {
        disabled: true,
      },
      value: '',
    },
    note: {
      label: '媒体账号备注',
      type: 'input',
      value: '',
    },
  };
};
